import React from 'react';
import { createRoot } from 'react-dom/client';
import './instrument';
import App from './App';
import { AmplitudeProvider } from './helpers/amplitudeContext';

// import * as serviceWorker from './serviceWorker';

import { Provider } from 'react-redux';
import { configureStore } from './redux/store';

const root = createRoot(document.getElementById('root'));

root.render(
    <Provider store={configureStore()}>
        <AmplitudeProvider>
            <App />
        </AmplitudeProvider>
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
